<button
  #btn
  [title]="config?.text"
  [disabled]="disabled"
  [attr.type]="!!type ? type : null"
  (click)="onClick.emit($event)"
  class="btn d-flex-inline align-items-center text-wrap"
  [ngClass]="ButtonClass"
>
  <svg-icon [src]="config?.prependSrc" *ngIf="config?.prependSrc && !loading" />

  <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

  <span
    *ngIf="!!config?.text"
    class="d-flex-inline text-wrap"
    [ngClass]="TextStyles"
    [innerText]="config?.text"
  ></span>

  <svg-icon [src]="config?.appendSrc" *ngIf="config?.appendSrc" />
</button>
